import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Link from 'react-router-dom/Link';
import ReactHtmlParser from 'react-html-parser';
import moment from 'moment';
import 'moment/locale/fr';
import {truncateText} from '../../../../app/utils/text';
import {withLocalize} from 'react-localize-redux';
import AddIcon from '@material-ui/icons/Add';
import PlaceholderImage from "../../../Schools/assets/img/placeholder-school-thumbnail.jpg";

class InstitutionsListItem extends Component {
    render() {
        const {institutions} = this.props;

        moment.locale('fr');

        const uri = this.props.translate('routes.institutions_details').replace(':slug', institutions.slug);

        let thumbnailStyles = {};

        if (institutions.featured_image && institutions.featured_image.listing && institutions.featured_image.listing !== '') {
            thumbnailStyles = {
                backgroundImage: 'url("' + institutions.featured_image.listing + '")',
            };
        } else {
            thumbnailStyles = {
                backgroundImage: `url(${PlaceholderImage})`,
            };
        }

        return (
            <div className="col-lg-3 col-md-6 col-sm-12" key={institutions.id}>
                <Link to={uri} className="item">
                    <div className='bg-image' style={thumbnailStyles}></div>
                    <div className="inner">
                        <div className="title">
                            {ReactHtmlParser(truncateText(institutions.title, 60))}
                        </div>
                        <div className="bottom">
                            <div className="types">
                                {institutions.types.map(type => (
                                    <div key={type.term_id} className="type-term">
                                       {type.name}
                                    </div>
                                ))}
                            </div>
                            <span className="btn-more"><AddIcon className="m-icon" /></span>
                        </div>
                    </div>
                </Link>
            </div>
        );
    }
}

InstitutionsListItem.propTypes = {
    institutions: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
};

export default withLocalize(InstitutionsListItem);


// WEBPACK FOOTER //
// ./src/features/Institutions/components/List/InstitutionsListItem.js